import { MaxUint256 } from '@ethersproject/constants/lib/bignumbers'
import { BigNumber } from 'ethers'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { getSISContract } from '~/contracts/getSISContract'
import { useVESISParams } from '~/hooks/useVESISParams'
import { sisTokenKeys } from '~/lib/queryKeys'
import { useWallet } from '~/lib/useWallet'

export function useApproveSISToken(amount?: BigNumber) {
	const { config, provider } = useVESISParams()

	const { signer, account } = useWallet()

	const queryClient = useQueryClient()

	const { data } = useQuery({
		queryKey: sisTokenKeys.allowance(config.chain.id, account),
		queryFn: () => {
			const contract = getSISContract(config, provider)

			return contract.allowance(account, config.votingEscrowAddress)
		},
		enabled: !!account,
	})

	const { isPending, mutate } = useMutation({
		mutationFn: async () => {
			const contract = getSISContract(config, provider).connect(
				signer
			)

			const tx = await contract.approve(
				config.votingEscrowAddress,
				MaxUint256
			)

			await tx.wait()
		},
		onSuccess() {
			queryClient.setQueryData(
				sisTokenKeys.allowance(config.chain.id, account),
				MaxUint256
			)
		},
		onError(error) {
			console.error('Error approving SIS token:', error)
		},
	})

	const needApprove = !!data && !!amount && (data.eq(0) || data.lt(amount))

	return {
		approve: mutate,
		isApproving: isPending,
		needApprove,
	}
}
